import {
	CallLogData,
	ParticipantNameCallFieldMappingConfig,
	ParticipantNameMappingFormat
} from '../../store/state/createJobState';

export default function CreateJobParticipantNameSummary(props: Props) {
	const mappings = getMappings();
	
	if (!mappings.length) {
		return (
			<div>
				<a role="button" onClick={props.onEditConfiguration}>Configure</a>
			</div>
		);
	}
	
	return (
		<div>
			{mappings.map((m, i) => (<div key={i}><span className="text-bold text-italic">{props.callLogData.headers[m.column] ?? 'Unknown'}:</span> {m.format} </div>))}
			<div><a role="button" onClick={props.onEditConfiguration}>Edit</a> | <a role="button" className="warning-link" onClick={props.onRemoveConfiguration}>Remove</a></div>
		</div>
	);

	function getMappings(): { format: string; column: number; }[] {
		const modeConfig = props.config.modeConfig;
		
		if (modeConfig.type === 'singleField') {
			return [
				{ 
					format: modeConfig.format === ParticipantNameMappingFormat.LastCommaFirst ? 'Last, First' : 'First Last', 
					column: modeConfig.columnIndex 
				}
			];
		} else {
			const result: { format: string; column: number; }[] = [];
			
			if (modeConfig.firstNameColumnIndex != null) {
				result.push({ format: 'First name', column: modeConfig.firstNameColumnIndex });
			}
			
			if (modeConfig.lastNameColumnIndex != null) {
				result.push({ format: 'Last name', column: modeConfig.lastNameColumnIndex });
			}
			
			return result;
		}
	}
}

interface Props {
	config: ParticipantNameCallFieldMappingConfig;
	callLogData: CallLogData;
	onEditConfiguration: () => void;
	onRemoveConfiguration: () => void;
}
